import type { QuoteProduct } from 'paintscout'
import omit from 'lodash/omit'

/**
 * A substrate product slot with no label and all-zero/false fields is an empty placeholder
 * (e.g. `{ product: { name: 'custom', label: '' }, custom: true }`) rather than a real product.
 * The rest of the app ignores these (see convert-areaSubstrate-products' legacyAreaSubstrateProduct),
 * so anything that surfaces substrate products should reuse this gate to stay consistent.
 */
export function isBlankSubstrateProduct(quoteProduct?: Partial<QuoteProduct>): boolean {
  if (!quoteProduct || !Object.keys(quoteProduct).length) return true
  const fields = quoteProduct as Record<string, unknown>
  return !quoteProduct?.product?.label && Object.keys(omit(fields, ['product', 'custom'])).every((key) => !fields[key])
}
